'use strict'

import DOMPurify from "dompurify"

var kilroy = kilroy || {}

kilroy.helpers = kilroy.helpers || {}

kilroy.helpers.init = function () {
}

/* Cookie helper functions
*******************************/
kilroy.helpers.getCookie = function (cname) {
  var name = cname + "="
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') { c = c.substring(1) }
    if (c.indexOf(name) === 0) { return c.substring(name.length, c.length) }
  }
  return ""
}

kilroy.helpers.setCookie = function (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 60 * 60 * 1000 * 24))
  var expires = "expires=" + d.toUTCString() + ";"
  var path = "path=/"
  document.cookie = cname + "=" + cvalue + "; " + expires + path
}

/* Google Tag Manager helper functions
*******************************/
kilroy.helpers.pushToDataLayer = function (eventName, pageCategory, buttonName) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': eventName,
    'pageCategory': pageCategory,
    'buttonName': buttonName,
    "sourceUrl": window.location.href,
  })
}

kilroy.helpers.initContactTrigger = () => {
  //Contact button fix
  var contactSliderTrigger = document.querySelectorAll('.js-contact-slider-trigger')
  var contactSlider = document.querySelector('.contact-slider')
  var stickyCtaButtons = document.querySelector('.contact-sticky-cta')
  var overlay = document.querySelector(".overlay")

  for (var x = 0; x < contactSliderTrigger.length; x++) {
    contactSliderTrigger[x].addEventListener('click', function () {

      stickyCtaButtons.classList.remove('contact-sticky-cta--show')
      stickyCtaButtons.classList.add('contact-sticky-cta--hide')
      contactSlider.classList.remove('contact-slider--hide')
      contactSlider.classList.add('contact-slider--show')
      overlay.classList.add("overlay--active")

    })
  }
}

kilroy.helpers.isElementInViewport = (el) => {
  var rect = el.getBoundingClientRect()

  return (
    rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
  )
}

kilroy.helpers.scrollStop = (callback, element) => {

  // Make sure a valid callback was provided
  if (!callback || typeof callback !== 'function') { return }

  // Setup scrolling variable
  var isScrolling
  // Listen for scroll events
  element.addEventListener('scroll', function (event) {
    // Clear our timeout throughout the scroll
    window.clearTimeout(isScrolling)

    // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(function () {

      // Run the callback
      callback()

    }, 66)

  }, false)

}
kilroy.helpers.initFlightTrigger = () => {
  //Flight button fix
  var flightSearchOpen = document.querySelectorAll(".flight-search-trigger")
  var flightSearchSection = document.querySelector(".flight-search-section")
  var bookAFlightSearch = document.querySelector('#book-a-flight-search-section')

  var overlay = document.querySelector(".overlay")
  var overlaysClose = document.querySelector(".overlays-close")

  if (bookAFlightSearch) {
    for (var i = 0; i < flightSearchOpen.length; i++) {
      flightSearchOpen[i].addEventListener("click", function () {
        this.setAttribute('href', '#book-a-flight-search-section')
        var sweetScroll
        if (window.innerWidth < 992) {
          sweetScroll = new SweetScroll({
            trigger: '.flight-search-trigger',
            offset: 70,
          })
        } else {
          sweetScroll = new SweetScroll({
            trigger: '.flight-search-trigger',
            header: '.site-navigation',
          })
        }
      })
    }
  } else if (flightSearchSection) {
    for (var x = 0; x < flightSearchOpen.length; x++) {
      flightSearchOpen[x].addEventListener("click", function () {
        var newUrl = kilroy.helpers.updateQueryString('flightsearchOverlay', true)
        window.history.replaceState({ path: newUrl }, '', newUrl)
        bodyScrollLock.disableBodyScroll()
        flightSearchSection.classList.add("flight-search-section--active")
        setTimeout(() => {
          overlay.classList.add("overlay--active")
          overlaysClose.classList.add('overlays-close--active')

        })
      })
    }
    if (kilroy.helpers.getParameterByName('flightsearchOverlay')) {
      flightSearchSection.classList.add("flight-search-section--active")
      overlay.classList.add("overlay--active")
      bodyScrollLock.disableBodyScroll()
      overlaysClose.classList.add('overlays-close--active')
    }

    //open the overlay when the back button in the browser is hit
    window.addEventListener('popstate', function () {
      if (kilroy.helpers.getParameterByName('flightsearchOverlay')) {
        flightSearchSection.classList.add("flight-search-section--active")
        overlay.classList.add("overlay--active")
        bodyScrollLock.disableBodyScroll()
        overlaysClose.classList.add('overlays-close--active')
      } else {
        flightSearchSection.classList.remove("flight-search-section--active")
        overlay.classList.remove("overlay--active")
        bodyScrollLock.enableBodyScroll()
        overlaysClose.classList.remove('overlays-close--active')
      }
    }, false)
  }
}

kilroy.helpers.getParameterByName = (name, url, decodeUri = true) => {
  if (!url) {
    url = window.location.href
  }
  name = name.replace(/[\[\]]/g, "\\$&")
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url)
  if (!results) {
    return ''
  }
  if (!results[2]) {
    return ''
  }
  if (decodeUri) {
    return decodeURIComponent(results[2].replace(/\+/g, " "))
  } else {
    return results[2]
  }
}

kilroy.helpers.updateQueryString = (key, value, url) => {
  if (!url) { url = window.location.href }
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
    hash

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      return url.replace(re, '$1' + key + "=" + value + '$2$3')
    }
    else {
      hash = url.split('#')
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '')
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1]
      }
      return url
    }
  }
  else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?'
      hash = url.split('#')
      url = hash[0] + separator + key + '=' + value
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1]
      }
      return url
    }
    else {
      return url
    }
  }
}

function sanitizeObject(obj) {
  // Iterate through the object properties
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = DOMPurify.sanitize(obj[key])
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      // Recursively sanitize nested objects
      sanitizeObject(obj[key])
    }
  }
  return obj
}
kilroy.helpers.sanitizeObject = sanitizeObject